<template lang="pug">
.container-groups
  .group-row(
    v-for="desktopGroup in desktopGroups",
    :key="desktopGroup.id",
    :id="'GroupList-row' + desktopGroup.id",
    @click='closeRightClickGroupsMenu(desktopGroup, $event)',
    :class="{ selected: groupIsSelected(desktopGroup) }"
  )
    .column.preview
      GroupRow(
        :ref='`grouprow${desktopGroup.id}`'
        :desktops="desktopGroup.DeviceDesktops",
        :desktopGroup='desktopGroup',
        @loadEditMediumInMediaEditor='loadEditMediumInMediaEditor',
        @reloadLeftComponent='reloadLeftComponent',
        @reloadRightComponent='reloadRightComponent',
        @showGroup='showGroup',
        @rightClickAction='rightClickAction',
        @openRightClickGroupsMenu='openRightClickGroupsMenu',
        @closeRightClickMenu='closeRightClickMenu',
        @closeLeftPanelContextMenu='closeLeftPanelContextMenu',
      )
  el-dialog(:close-on-click-modal="false",
    :visible.sync="desktopGroupVisible",
    @close='closeGroupView()',
    :modalAppendToBody="true",
    :fullscreen="true"
  )
    GroupView(v-if='desktopGroupVisible', :desktopGroup='desktopGroup', @loadEditMediumInMediaEditor="loadEditMediumInMediaEditor")
  el-dialog(:close-on-click-modal="false",
    :visible.sync="desktopGroupEditorVisible",
    @close='closeGroupEditor()',
    :modalAppendToBody="true"
  )
    GroupEdit(v-if='desktopGroupEditorVisible', :desktopGroup='desktopGroup', @closeGroupEditor="closeGroupEditor")
  RightClickDesktopGroupsMenu(ref='RightClickDesktopGroupMenu', @rightClickGroupAction='rightClickGroupAction')
  ConfirmDialog(
    v-if='confirmDialogVisible',
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
</template>

<script>
import ShortMediaList from '../Common/ShortMediaList'
import mediaUtils from '../Common/mediaUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import ScheduleDayTimeEditor from '../Common/ScheduleDayTimeEditor'
import GroupView from './GroupView'
import GroupRow from './GroupRow'
import GroupEdit from './GroupEdit'
import RightClickDesktopGroupsMenu from './RightClickDesktopGroupsMenu'
import deviceRCLCK from '../Common/deviceRCLCK.mixin'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  mixins: [mediaUtils, deviceRCLCK, deviceUtils],
  components: {
    ShortMediaList,
    GroupView,
    GroupRow,
    GroupEdit,
    ScheduleDayTimeEditor,
    RightClickDesktopGroupsMenu,
    ConfirmDialog
  },
  props: ['side', 'desktopGroups'],
  data () {
    return {
      errors: {
      },
      desktopGroupVisible: false,
      desktopGroupEditorVisible: false,
      desktopGroup: undefined
    }
  },
  async created () {
  },
  watch: {
    // value: function (newVal, oldVal) {
    // }
  },
  methods: {
    reloadLeftComponent () {
      this.$emit('reloadLeftComponent')
    },
    reloadRightComponent () {
      this.$emit('reloadRightComponent')
    },
    closeGroupEditor () {
      this.desktopGroupEditorVisible = false
    },
    async rightClickGroupAction (data) {
      if (data.action === 'editGroup') {
        this.desktopGroup = data.desktopgroup
        this.desktopGroupEditorVisible = true
        return
      }
      data.devicegroupsAction = true
      await this.rightClickAction(data)
    },
    openRightClickGroupsMenu (data) {
      for (const ref of Object.keys(this.$refs).filter(ref => ref.indexOf('grouprow') > -1)) {
        if (this.$refs[ref][0]) this.$refs[ref][0].closeRightClickDesktopMenu()
      }
      this.$emit('closeLeftPanelContextMenu')
      this.$refs.RightClickDesktopGroupMenu.openRightClickMenu(data.desktopGroup, data.$event)
    },
    closeRightClickMenu () {
      this.closeRightClickGroupsMenu()
    },
    closeRightClickGroupsMenu (group, $event) {
      this.$refs.RightClickDesktopGroupMenu.closeRightClickMenu(group, $event)
    },
    closeLeftPanelContextMenu () {
      this.$emit('closeLeftPanelContextMenu')
    },
    showGroup (desktopGroup) {
      this.desktopGroupVisible = true
      this.desktopGroup = desktopGroup
    },
    closeGroupView () {
      this.desktopGroup = undefined
      this.desktopGroupVisible = false
    },
    loadEditMediumInMediaEditor (medium) {
      this.$emit('loadEditMediumInMediaEditor', medium)
    },
    groupIsSelected (desktopGroup) {
      return this.$store.state.Device.desktop_groups_selected_right.find(dg => dg.id === desktopGroup.id)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-groups {
  margin-top: 6px;
  border-top: $--border-light;
}
.group-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  border-bottom: $--border-light;
  padding: 1px;
  margin: 0px;
  &.selected {
    padding: 0px;
    margin: 1px;
  }
  // margin: 1px;
  .column {
    border: 0px dotted blue;
    font-size: $--font-size-base;
    &.name {
      overflow: hidden;
      white-space: nowrap;
      width: 50%;
      .counter, .address {
        color: $--color-text-placeholder;
      }
      .name {
        color: $--color-text-regular;
      }
    }
  }
}
.preview {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/GroupList.vue